import ControllerBase from '../../../../global/js/ControllerBase';
import { fromEvent } from 'rxjs';
import { OrganismProductInfoProps } from './o-product-info.data';
import UIkit from 'uikit';

// link types to molecule type, in case of changes in the future
type ProductId = OrganismProductInfoProps['productInfo']['productId'];
type FetchURL = string;

/** A list of dom element references available to this component */
interface ComponentRefs {
	infoClickIcon: 'infoClickIcon',
	modalWrapper: 'modalWrapper',
}
export default class ControllerProductInfo extends ControllerBase<ComponentRefs> {

	/** The product ID */
	private readonly productId: ProductId;

	/** The ajax fetch URL base to get related product data, when clicking on the "i" icon */
	private readonly fetchUrl: FetchURL;

	constructor(element: HTMLElement) {
		super(element);

		// set product ID
		this.productId = this.$element.dataset.productid || '';
		this.fetchUrl = this.$element.dataset.fetchurl || '';

		this.init();
	}

	private init(): void {
		this.observeInfoClick();
	}

	/**
	 * Listen for clicks on the product "i" button
	 * @returns void
	 */
	private observeInfoClick(): void {
		this.$references.infoClickIcon && fromEvent(this.$references.infoClickIcon, 'click')
			.subscribe((e: Event | MouseEvent) => {
				e.preventDefault();

				// fetch data and show modal
				this.getProductModalData(this.productId)
				.then(html => this.showModal(html))
				.finally(() => {
					if (e && e.target) {
						// for some reason UIkit adds a hidden attribute to the clicked anchor, so remove it since we are opening the modal dynamically
						(e.target as HTMLAnchorElement).removeAttribute('hidden');
					}
				});
			});
	}

	/**
	 * If html, show the product modal
	 * @param  {string} html
	 * @returns void
	 */
	private showModal(html: string): void {

		if (html && this.$references.modalWrapper) {
			this.$references.modalWrapper.innerHTML = html;

			const modal = (this.$references.modalWrapper as HTMLDivElement)
			.querySelector('div.uk-modal-container');
			modal && UIkit.modal(modal).show();

		}
	}

	/**
	 * Get product data by ID
	 * @param  {ProductId} productId
	 * @returns Promise<string> The rendered modal template from: ./o-product-info.modal.template.twig
	 */
	private async getProductModalData(productId: ProductId): Promise<string> {
		if (!productId) return '';

		const url = new URL(this.fetchUrl);
		url.searchParams.append('id', productId);

		return await fetch(url.toString(), {
			method: 'GET',
			// credentials: 'same-origin',
			headers: {
				'Content-Type': 'text/html',
			},
		})
		.then((response) => response.text())
		.then((renderedTemplate: string) => {
			return renderedTemplate;
		})
		.catch(e => {
			// console.log(`Failed to get product data for product ${this.productId}`, e);
			// return e;
			return '';
		})
	}
}
